export const DEFAULT_ERROR_GENERATE_TOKEN_MESSAGE =
  'Ocorreu um erro ao enviar o seu código, tente novamente mais tarde.'

export const INCORRECT_TOKEN_MESSAGE = 'Código incorreto. Tente novamente.'

export const EXPIRED_TOKEN_MESSAGE = 'Código expirado. Solicite um novo código.'
